<template>
  <div class="profile-link-modal__cover" @click.self="onClickModalCover">
    <div class="profile-link-modal__content">
      <div class="profile-link-modal__header">
        <CloseCircleOutline
          class="profile-link-modal__close-icon"
          @click="onClickCloseButton"
        />
        <span>設定をONにするとできること</span>
      </div>
      <div class="profile-link-modal__body">
        <div class="profile-link-modal__sub-text">
          この設定は、プロフィールを公開している方が、プロフィールに設定したニックネームから贈り主名を変更してギフトカードを作成したときに表示されます。
        </div>
        <div class="profile-link-modal__main-text">
          設定をONにすると、今回作成したギフトカード上の「贈り主名」の箇所が、プロフィール画面へのリンクに変わります。
        </div>
        <div class="profile-link-modal__image-area">
          <img
            src="../../../../../../images/profile-link-sample.svg"
            class="profile-link-modal__image"
          />
        </div>
        <div class="profile-link-modal__main-text">
          プロフィールにアクセスできると、お相手とギフトのやりとりがしやすくなりますので、問題がなければ設定をONにしていただくことをおすすめします。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseCircleOutline from '../../../atoms/svg_icons/CloseCircleOutline.vue'

export default {
  components: {
    CloseCircleOutline
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickCloseButton() {
      this.$emit('clicked-close')
    }
  }
}
</script>
<style lang="scss" scoped>
.profile-link-modal {
  &__cover {
    // TODO: z-index 全体を管理する際に適切なファイル、値にする
    // header が 100 なので 101 をセットする
    z-index: 101;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 92%;
    padding: 0 4%;
    background-color: $dark_black_cover;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
  }

  &__content {
    background: $white;
    border-radius: 8px;
    text-align: center;
    width: 100%;
    max-width: 343px;
    margin: auto 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  &__header {
    @extend %body-bold;
    padding: 24px 24px 16px 24px;
    display: flex;
    gap: 8px;
    border-bottom: solid $gray-1 1px;

    @media screen and (max-width: $small-contents-width) {
      padding-left: 4.3%;
      padding-right: 4.3%;
    }
  }

  &__body {
    padding: 24px 24px 32px 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media screen and (max-width: $small-contents-width) {
      padding-left: 4.3%;
      padding-right: 4.3%;
    }
  }

  &__main-text {
    @extend %caption;
    color: $black;
    text-align: left;

    span {
      display: block;
    }
  }

  &__image-area {
    width: 100%;
    border: solid $gray-2 1px;
    border-radius: 16px;
  }

  &__sub-text {
    @extend %minimal;
    color: $gray-1;
    text-align: left;
  }
}
</style>
